import React, { useState } from "react";
import { Link } from "react-router-dom";
import { portalApi } from "../../api/portalApi";

export default function PortalForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await portalApi.post("/portal/auth/forgot-password", { email });
    } finally {
      // Sempre mostra a mesma mensagem, mesmo se o e-mail não existir — evita enumeração de contas.
      setSent(true);
      setSubmitting(false);
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div
        className="d-flex flex-column gap-3 p-4"
        style={{
          width: "min(380px, 90vw)",
          background: "var(--color-surface)",
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-lg)",
        }}
      >
        <div>
          <h4 className="mb-1">Esqueci minha senha</h4>
          <p className="text-secondary mb-0" style={{ fontSize: 13 }}>
            Informe o e-mail cadastrado no portal.
          </p>
        </div>

        {sent ? (
          <div className="text-secondary" style={{ fontSize: 13.5 }}>
            Se o e-mail informado tiver uma conta ativa no portal, enviamos um link de redefinição de senha para ele.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
            <div className="field">
              <label className="form-label" style={{ fontSize: 12 }}>
                E-mail
              </label>
              <input
                type="email"
                className="form-control"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
              {submitting ? "Enviando…" : "Enviar link de redefinição"}
            </button>
          </form>
        )}
        <Link to="/portal/login" style={{ fontSize: 12.5, textAlign: "center", color: "var(--color-neutral-400)" }}>
          Voltar para o login
        </Link>
      </div>
    </div>
  );
}
